import { render, staticRenderFns } from "./DatePickerComponent.vue?vue&type=template&id=71d3dcc8"
import script from "./DatePickerComponent.vue?vue&type=script&lang=js"
export * from "./DatePickerComponent.vue?vue&type=script&lang=js"
import style0 from "./DatePickerComponent.vue?vue&type=style&index=0&id=71d3dcc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/i18n/template/components/DatePickerComponent.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FVolumes%2FSSD%2Fjenkins_workspace%2Fworkspace%2FJL_UAT_MPORTAL%2Fsrc%2Fcomponents%2FDatePickerComponent.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports